import React from "react";

import "../styles/common/createTemplate.css";
import { ReactComponent as CreatePlusIcon } from "../../../../../assets/images/environment/CreatePlusIcon.svg";

export default function CreateTemplate(props) {
  const { handleAddTemplateClick } = props;
  return (
    <div
      className="createTemplateContainer"
      onClick={handleAddTemplateClick}
    >
      <CreatePlusIcon className="createTemplatePlusIcon" aria-hidden />
      <div>New Template</div>
    </div>
  );
}
